import React from 'react'
import "./presentation.scss"
import img1 from "../../images/association-dance-flowers3.jpg"
import img2 from "../../images/contemporain4.png"
function Presentation() {
  return (
    <div className='contain'>
       <section class="container">


<div class="row align-items-center" /**Premier article */>
    <div class="col-12 col-md-4">
        <h2>Une équipe soudée</h2>
        <p class="mt-5">...et bien plus qu’un simple groupe de danseurs : c’est une véritable famille unie par la passion du mouvement et du partage.
        Chaque membre, qu’il soit débutant ou confirmé, trouve sa place au sein d’une équipe soudée où l’entraide et la bienveillance sont au cœur de chaque entraînement.
        </p>
    </div>
    <div class="col-12 col-md-8">
        <img src={img1} class="img-pres" alt="Equipe,danse,ravine Blanche"/>
    </div>
</div>

<div class="hero--diagonal">
  <div class="hero__content">
    <p className='diag-paragraphe'>"La danse est le langage du cœur, une mélodie du corps qui transforme chaque mouvement en émotion." 💃✨</p>
  </div>
</div >
</section>

<section className='container'><div class="row align-items-center inverse" /**second article */>
    <div class="col-12 col-md-4">
        <h2>Notre force</h2>
        <p class="mt-5">Leur complicité se ressent aussi bien en répétition que sur scène, où leur énergie collective illumine chacune de leurs performances. Plus qu’une association, c’est un lieu où naissent des amitiés fortes et où l’esprit d’équipe fait toute la différence.</p>
    </div>
    <div class="col-12 col-md-8">
        <img src={img2} class="img-pres" alt="contemporain"/>
    </div>
</div></section>
</div>
  )
}

export default Presentation
{/* <div class="shadow-title" >
   DanceFlowers
</div> */}/**coupure*/